import React from "react";
import "../style.css";
export const CustomSelect = ({
  values,
  optionHeading,
  selectedValue,
  handleChange,
}) => {
  return (
    <div>
      <select
        value={selectedValue}
        onChange={handleChange}
        id="financialYear"
        className="select-financial-year"
        style={{
          width: "90%",
          fontSize: "14px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          height: "2.7em",
          color: "#007bff",
        }}
      >
        <option value="" disabled hidden>
          {optionHeading || "Select"}
        </option>
        {values.map((item) => (
          <option key={item.label} value={item.value} style={{color:"black"}}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomSelect;
